import React from 'react';

const HeroSection = () => {
  return (
    <div className="relative h-[20vh] md:h-[30vh] flex items-center justify-center text-white text-center overflow-hidden rounded-2xl mb-4 md:mb-6">
      {/* Background Image with Original Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[rgba(9,39,74,1)] to-[rgba(4,136,175,1)] z-0">
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute right-0 top-0 w-32 h-32 bg-white opacity-5 rounded-full -translate-y-1/2 translate-x-1/3"></div>
      <div className="absolute left-0 bottom-0 w-16 h-16 bg-[#DC3465] opacity-10 rounded-full translate-y-1/3 -translate-x-1/4"></div>
      
      {/* Subtle Pattern Overlay */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1IiBoZWlnaHQ9IjUiPgo8cmVjdCB3aWR0aD0iNSIgaGVpZ2h0PSI1IiBmaWxsPSIjZmZmIiBmaWxsLW9wYWNpdHk9IjAuMDMiPjwvcmVjdD4KPHBhdGggZD0iTTAgNUw1IDBaTTYgNEw0IDZaTS0xIDFMMSAtMVoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLW9wYWNpdHk9IjAuMDUiPjwvcGF0aD4KPC9zdmc+')] opacity-20"></div>

      {/* Content with Enhanced Animation */}
      <div className="relative z-10 max-w-4xl mx-auto px-4">
        <h1 className="font-extrabold text-4xl sm:text-5xl md:text-6  xl mb-2 drop-shadow-lg animate-[fadeIn_1s_ease-out]">
          Bienvenidos a <span className="text-[#DC3465]">RDS</span>
        </h1>

        <p className="text-3xl sm:text-lg md:text-2xl max-w-2xl mx-auto drop-shadow-md animate-[fadeIn_1.5s_ease-out]">
          Conectando nuestra comunidad para crecer juntos.
        </p>
      </div>
    </div>
  );
};

// Add animation keyframes using CSS
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(10px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;
  document.head.appendChild(style);
}

export default React.memo(HeroSection);